import React from 'react';
import { useTranslation } from 'react-i18next';

const MutualConnections = ({ mutuals, onUserSelect }) => {
    const { t } = useTranslation();

    if (!mutuals || mutuals.length === 0) {
        return null;
    }

    return (
        <div className="my-4 p-4 bg-gray-800/50 rounded-lg">
            <h4 className="font-bold text-white mb-2">{t('mutualConnections.title')}</h4>
            <div className="flex items-center gap-2">
                {mutuals.slice(0, 5).map(user => (
                    <img
                        key={user.id}
                        src={user.photoURL}
                        alt={user.displayName}
                        className="w-10 h-10 rounded-full cursor-pointer"
                        onClick={() => onUserSelect(user.id)}
                        title={user.displayName}
                    />
                ))}
                {mutuals.length > 5 && (
                    <div className="w-10 h-10 rounded-full bg-gray-700 flex items-center justify-center text-white">
                        +{mutuals.length - 5}
                    </div>
                )}
            </div>
        </div>
    );
};

export default MutualConnections;